/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef, useCallback, useState } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { ImLocation2 } from 'react-icons/im';
import { FaPhoneAlt } from 'react-icons/fa';
import { GrMail } from 'react-icons/gr';
import { useToast } from '../../../hooks/toast';
import framefacebook from '../../../assets/Home/framefacebook.svg';
import framewhatsapp from '../../../assets/Shared/framewhatsapp.svg';
import frametelegram from '../../../assets/Home/frametelegram.svg';

import Button from '../../Button';
import Input from '../../Input';

import { Content, Main, FormWrapper, FileDiv, FormDiv } from './styles';
import getValidationErrors from '../../../utils/getValidationErrors';
import CoreService from '../../../services/core';
import Select from '../../Select';
import FileInputSpecial from './FileInputSpecial';
import { isValidCpf } from '../../../utils/isValidCpf';

interface ContactSectionProps {
  isPage?: boolean;
  isButtonLarge?: boolean;
  sgl?: string;
  code?: string;
  handleClose?: any;
}

const ConteudoPortal: React.FC<ContactSectionProps> = ({
  isPage = false,
  isButtonLarge = false,
  handleClose,
  sgl,
  code,
  ...rest
}) => {
  const services = { coreService: new CoreService() };
  const formRef = useRef<FormHandles>(null);
  const { addToast } = useToast();

  const categoriasOptions = [
    { value: 'Confirmação dos Dados', label: 'Confirmação dos Dados' },
    {
      value: 'Consulta Completa de Dados',
      label: 'Consulta Completa de Dados',
    },
    {
      value: 'Consulta de Compartilhamento dos Dados',
      label: 'Consulta de Compartilhamento dos Dados',
    },
    {
      value: 'Consulta Simples de Dados',
      label: 'Consulta Simples de Dados',
    },
    { value: 'Correção dos Dados', label: 'Correção dos Dados' },
    {
      value: 'Esquecimento (Exclusão) dos Dados',
      label: 'Esquecimento (Exclusão) dos Dados',
    },
    {
      value: 'Oposição ao Tratamento dos Dados',
      label: 'Oposição ao Tratamento dos Dados',
    },
    { value: 'Portabilidade dos Dados', label: 'Portabilidade dos Dados' },
    { value: 'Revogar Consentimento', label: 'Revogar Consentimento' },
    { value: 'Outros', label: 'Outros' },
  ];
  const [disable, setDisable] = useState(false);

  const schema = Yup.object().shape({
    type: Yup.string().required('Modalidade é obrigatória'),
    full_name: Yup.string().required('Nome é obrigatório'),
    email: Yup.string()
      .required('E-mail é obrigatório')
      .email('Digite um email válido'),
    cpf: Yup.string()
      .test('cpf-validation', 'CPF Inválido', value => {
        const isValid = isValidCpf(value);
        return isValid;
      })
      .required('Por favor preencha o cpf'),
    birth_date: Yup.string().matches(
      /^\d{2}\/\d{2}\/\d{4}$/,
      'Por favor preencha a data de nascimento',
    ),
    phone: Yup.string()
      .required('Por favor preencha o número de telefone')
      .min(14, 'Por favor preencha o número de telefone'),
    file: Yup.string().required('Por favor anexe o arquivo'),
  });

  const handleSubmit = useCallback(
    async data => {
      try {
        formRef.current?.setErrors({});

        await schema.validate(data, {
          abortEarly: false,
        });
        setDisable(true);
        const formData = new FormData();

        formData.append('type', data.type);
        formData.append('name', data.full_name);
        formData.append('email', data.email);
        formData.append('birth_date', data.birth_date);
        formData.append('cpf', data.cpf);
        formData.append('phone', data.phone);

        if (data.file instanceof File) {
          formData.append('file', data.file);
        }

        const response = await services.coreService.contactLGPD(formData);
        addToast({
          type: 'success',
          title: response.data.message,
          description: response.data.sub_message,
        });

        formRef.current.reset();
        setDisable(false);

        setTimeout(function () {
          window.location.reload();
        }, 3000);
      } catch (err: any) {
        const { ...error } = err;
        setDisable(false);

        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
          return;
        }

        addToast({
          type: 'error',
          title: 'Erro no Registro',
          description: `Ocorroeu um erro ao tentar registrar o Contato`,
        });
      }
    },
    [addToast, services],
  );

  return (
    <>
      <Main isPage={isPage} {...rest}>
        <Content>
          <FormDiv>
            <Form ref={formRef} onSubmit={handleSubmit}>
              <h1 className="title">Formulário de Contato</h1>
              <FormWrapper>
                <div className="input-container">
                  <Select
                    name="type"
                    placeholder="Tipo de solicitação"
                    options={categoriasOptions}
                    className="select"
                  />
                </div>
                <Input
                  name="full_name"
                  placeholder="Nome completo"
                  schema={schema}
                />
                <Input
                  cpf
                  name="cpf"
                  className="cpf"
                  placeholder="CPF"
                  schema={schema}
                />
                <Input phone name="phone" placeholder="Telefone" />
                <Input name="birth_date" placeholder="Data de nascimento" />
                <Input
                  name="email"
                  placeholder="E-mail para comunicação de retorno"
                />
                <FileDiv>
                  <p style={{ fontWeight: 'bold', marginBottom: '20px' }}>
                    Envie uma foto frontal (selfie) com o documento ao lado (RG
                    ou CNH).
                  </p>
                  <FileInputSpecial name="file" title="Selecione um Arquivo" />
                </FileDiv>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: 20,
                  }}
                >
                  <Button
                    type="submit"
                    color="orange"
                    padding="2"
                    className="button"
                    disabled={disable}
                  >
                    ENVIAR
                  </Button>
                </div>
              </FormWrapper>
            </Form>
          </FormDiv>
        </Content>
      </Main>
    </>
  );
};

export { ConteudoPortal };
